export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-wireframes-8f866247d015d625c47cad83b5be962e.png";